import { useTranslation } from 'react-i18next';

interface NormChipGridProps {
  norms: { id: number; name: string }[];
  value: number | null;
  /** Norm names already used on the project's layers; outlined as suggestions. */
  suggested?: string[];
  onPick: (id: number | null, name: string | null) => void;
}

/** Compact norm picker: every norm as a small chip (6 per row) plus "No norm", instead of a
 *  long dropdown list. */
export function NormChipGrid({ norms, value, suggested = [], onPick }: NormChipGridProps) {
  const { t } = useTranslation();
  const chip = (selected: boolean, hint: boolean) =>
    `h-7 rounded text-[11px] font-medium transition-colors ${
      selected
        ? 'bg-lime-400 text-black'
        : `text-gray-100 hover:bg-lime-400 hover:text-black ${
            hint ? 'bg-white/10 ring-1 ring-inset ring-lime-400/60' : 'bg-white/[0.06]'
          }`
    }`;
  return (
    <div className="grid grid-cols-6 gap-1">
      {norms.map((norm) => (
        <button
          key={norm.id}
          type="button"
          onClick={() => onPick(norm.id, norm.name)}
          aria-pressed={value === norm.id}
          className={chip(value === norm.id, suggested.includes(norm.name))}
        >
          {norm.name}
        </button>
      ))}
      <button
        type="button"
        onClick={() => onPick(null, null)}
        aria-pressed={value === null}
        className={`col-span-2 ${chip(value === null, false)}`}
      >
        {t('workspace.panel.surfaces.noNorm')}
      </button>
    </div>
  );
}
